import { useEffect, useState } from "react";

export const useScreenOrientation = () => {
  const [phoneOrientation, setPhoneOrientation]: any = useState({
    portrait: true,
    landscape: false,
  });
  useEffect(() => {
    const initialScreenOrientation = screen?.orientation?.type?.split("-")[0];
    function changeOrientation(e: any) {
      const splitTargetType = e?.target?.type?.split("-")[0];
      if (splitTargetType === "portrait") {
        setPhoneOrientation({
          portrait: true,
          landscape: false,
        });
        return;
      }
      if (splitTargetType === "landscape" && screen?.orientation?.angle > 0) {
        setPhoneOrientation({
          portrait: false,
          landscape: true,
        });
      } else {
        setPhoneOrientation({
          portrait: true,
          landscape: false,
        });
      }
      return;
    }
    if (initialScreenOrientation === "portrait") {
      setPhoneOrientation({
        portrait: true,
        landscape: false,
      });
    }
    if (
      initialScreenOrientation === "landscape" &&
      screen?.orientation?.angle > 0
    ) {
      setPhoneOrientation({
        portrait: false,
        landscape: true,
      });
    }
    screen?.orientation?.addEventListener?.("change", changeOrientation);
    return () => window?.removeEventListener?.("change", changeOrientation);
  }, []);
  return phoneOrientation;
};
